import { render, staticRenderFns } from "./clientManageFrame.vue?vue&type=template&id=59b3d8b8&scoped=true"
import script from "./clientManageFrame.vue?vue&type=script&lang=js"
export * from "./clientManageFrame.vue?vue&type=script&lang=js"
import style0 from "./clientManageFrame.vue?vue&type=style&index=0&id=59b3d8b8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b3d8b8",
  null
  
)

export default component.exports